import { appStore } from '@/store';
import { features } from '@/lib';
import type { FormState } from '@/store/models/form/types';

/* === Begin Types === */
type CrsState = Pick<FormState, 'crsTaxDetails'>;
/* === End Types === */

const getCrsState = (formState: FormState): CrsState => {
  const { crsTaxDetails } = formState;
  return {
    crsTaxDetails,
  };
};

const isEligibleForCRS = (): boolean => {
  const { form: formState } = appStore.getState();
  const { onboardOption } = formState;
  const isSignup = onboardOption.value === 'signup';

  return isSignup && features.isActive('shouldShowCRSTaxCollectionSection');
};

export { getCrsState, isEligibleForCRS };
